module.exports = __webpack_public_path__ + "static/media/settings.117f2fc4.svg";